import api from '../request';
const helpService = {
    // 查询列表
    queryHelp(url, params) {
        return api.post(url, params);
    }
}
export default helpService;